import React from 'react';

export default function FloatingCTA() {
  const billetUrl = "https://billet.eventbilletten.dk/seller/foreningen-rbike-zd1k";

  const socials = [
    {
      name: "Facebook",
      icon: "fa-brands fa-facebook-f",
      url: "https://www.facebook.com/Orbike/",
      hoverBg: "hover:bg-[#1877F2] hover:border-[#1877F2]",
    },
    {
      name: "Instagram",
      icon: "fa-brands fa-instagram",
      url: "https://www.instagram.com/orbike_eventet/",
      hoverBg: "hover:bg-gradient-to-tr hover:from-amber-500 hover:via-pink-500 hover:to-purple-600 hover:border-pink-500",
    },
    {
      name: "YouTube",
      icon: "fa-brands fa-youtube",
      url: "https://www.youtube.com/channel/UCbp5b3RJPR4NbWml_U-joHw",
      hoverBg: "hover:bg-[#FF0000] hover:border-[#FF0000]",
    },
  ];

  return (
    <aside
      aria-label="Hurtige links og sociale medier"
      className="fixed right-3 sm:right-5 bottom-5 sm:bottom-6 z-40 flex flex-col items-center gap-2.5 sm:gap-3"
    >
      {/* Sociale links */}
      <div className="flex flex-col items-center gap-2 sm:gap-2.5 bg-[#0e1018]/80 backdrop-blur-md p-1.5 rounded-full border border-slate-800/80 shadow-2xl shadow-black/80">
        {socials.map((s) => (
          <a
            key={s.name}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Følg ØrBike på ${s.name}`}
            className={`group relative w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-[#161824]/90 text-slate-300 hover:text-white border border-slate-700/60 ${s.hoverBg} flex items-center justify-center text-center transition-all duration-300 ease-out hover:scale-110 active:scale-95 shadow-md`}
          >
            {/* Ikon placeret i midten */}
            <i className={`${s.icon} text-base sm:text-lg`} aria-hidden="true"></i>

            {/* Hover tooltip */}
            <span className="pointer-events-none absolute right-full mr-3 top-1/2 -translate-y-1/2 px-2.5 py-1 rounded-lg bg-[#090a0f] border border-slate-700 text-[11px] font-bold text-white whitespace-nowrap opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 shadow-xl">
              {s.name}
            </span>
          </a>
        ))}
      </div>

      {/* Primær Køb Billet CTA Knap */}
      <a
        href={billetUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Køb billet til ØrBike 2026 på Eventbilletten"
        className="group relative w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-gradient-to-tr from-pink-600 via-pink-500 to-purple-600 text-white flex items-center justify-center text-center shadow-[0_0_25px_rgba(255,42,141,0.6)] hover:shadow-[0_0_35px_rgba(255,42,141,0.95)] border border-pink-400/50 hover:border-white transition-all duration-300 ease-out hover:scale-110 active:scale-95"
      >
        {/* Billet ikon centreret i knappen */}
        <i className="fa-solid fa-ticket text-xl sm:text-2xl transition-transform duration-300 group-hover:rotate-12" aria-hidden="true"></i>

        {/* Hover Tooltip */}
        <span className="pointer-events-none absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-1.5 rounded-lg bg-[#090a0f] border border-pink-500/50 text-xs font-bold text-white uppercase tracking-wider whitespace-nowrap opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 shadow-2xl flex items-center gap-1.5">
          <span>Køb billet</span>
          <i className="fa-solid fa-arrow-up-right-from-square text-[10px] text-pink-400" aria-hidden="true"></i>
        </span>
      </a>
    </aside>
  );
}
